"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventAutoFillPassword = void 0;
const react_1 = __importDefault(require("react"));
const style = {
    position: 'absolute',
    opacity: 0,
};
const PreventAutoFillPassword = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("input", { name: "ignoreFieldName", type: "text", style: style }),
    react_1.default.createElement("input", { name: "ignoreFieldPassword", type: "password", style: style })));
exports.PreventAutoFillPassword = PreventAutoFillPassword;
exports.PreventAutoFillPassword.displayName = 'PreventAutoFillPassword';
//# sourceMappingURL=PreventAutoFillPassword.js.map